module.exports = __webpack_public_path__ + "img/Gomeeasecard.fa40df4c.png";